/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { assetUrl } from '@intercom/pulse/helpers/asset-url';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export function sourceIconProps(sourceType: string): {
  icon?: InterfaceIconName;
  iconUrl?: string;
} {
  if (sourceType === 'shopify') {
    return { icon: 'shopping-cart' as InterfaceIconName };
  }
  if (sourceType === 'hubspot') {
    return { iconUrl: assetUrl('/assets/images/knowledge-hub/icons/hubspot.svg') };
  }
  return { iconUrl: assetUrl(`/assets/images/knowledge-hub/icons/${sourceType}.png`) };
}
